import React from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';

function CelebrationConfetti() {
  const { width, height } = useWindowSize();
  return (
    <Confetti
      width={width}
      height={height}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
      }}
    />
  );
}

export default CelebrationConfetti;
